import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ChargingStations from '../views/ChargerLocator.vue'
import About from '../views/AboutView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    // component: () => import('../views/AboutView.vue')
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/charging-stations',
    name: 'chargerLocator',
    component: ChargingStations
  },
  {
    path: '/contact-us',
    name: 'contactUs',
    component: () => import('../views/ContactUs.vue')
  },
  {
    path: '/no-cost-model',
    name: 'no-cost-model',
    component: () => import('../views/NoCostModel.vue')
  }
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// Global navigation guard to scroll to the top on route change
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

export default router
